import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiShield, FiMenu, FiX } = FiIcons;

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-gray-900/95 backdrop-blur-lg shadow-lg' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <motion.div 
            className="flex items-center space-x-4"
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
          >
            <div className="relative">
              <div className="w-12 h-12 bg-gradient-to-br from-emerald-500 to-green-700 rounded-xl flex items-center justify-center shadow-lg">
                <SafeIcon icon={FiShield} className="w-7 h-7 text-white" />
              </div>
              <div className="absolute -bottom-1 -right-1 w-4 h-4 bg-emerald-400 rounded-full animate-pulse"></div>
            </div>
            <div>
              <span className="text-2xl font-bold text-white" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>vMLRO</span>
              <p className="text-xs text-emerald-300 font-medium">TruSecure SRL</p>
            </div>
          </motion.div>

          <nav className="hidden lg:flex items-center space-x-1">
            {[
              { id: 'problem', label: 'The Challenge' },
              { id: 'solutions', label: 'Our Services' },
              { id: 'differentiators', label: 'Why Choose Us' },
              { id: 'use-cases', label: 'Compliance Cases' }
            ].map((item, index) => (
              <button 
                key={index}
                onClick={() => scrollToSection(item.id)}
                className="text-gray-300 hover:text-emerald-400 transition-colors font-medium px-4 py-2 rounded-lg hover:bg-white/5"
              >
                {item.label}
              </button>
            ))}
            <button 
              onClick={() => scrollToSection('contact')}
              className="ml-4 bg-gradient-to-r from-emerald-600 to-green-700 text-white px-6 py-3 rounded-lg hover:from-emerald-700 hover:to-green-800 transition-all duration-300 font-semibold shadow-lg"
            >
              Get Started
            </button>
          </nav>

          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden w-12 h-12 flex items-center justify-center rounded-lg hover:bg-white/10 transition-colors"
          >
            <SafeIcon icon={isMenuOpen ? FiX : FiMenu} className="w-6 h-6 text-white" />
          </button>
        </div>

        {isMenuOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="lg:hidden border-t border-gray-700 py-4"
          >
            <nav className="flex flex-col space-y-2">
              {[
                { id: 'problem', label: 'The Challenge' },
                { id: 'solutions', label: 'Our Services' },
                { id: 'differentiators', label: 'Why Choose Us' },
                { id: 'use-cases', label: 'Compliance Cases' }
              ].map((item, index) => (
                <button 
                  key={index}
                  onClick={() => scrollToSection(item.id)}
                  className="text-gray-300 hover:text-emerald-400 transition-colors font-medium text-left px-4 py-3 rounded-lg hover:bg-white/5"
                >
                  {item.label}
                </button>
              ))}
              <button 
                onClick={() => scrollToSection('contact')}
                className="bg-gradient-to-r from-emerald-600 to-green-700 text-white px-6 py-3 rounded-lg hover:from-emerald-700 hover:to-green-800 transition-all duration-300 font-semibold"
              >
                Get Started
              </button>
            </nav>
          </motion.div>
        )}
      </div>
    </header>
  );
};

export default Header;